/**
 * 监测区间国际化
 * date：2022 03 07
 */
 export default {
    detection:{
        mInterval:'监测区间',
        unitMeasurement:'计量单位',
        intervalValue:'区间数值',
        onlyNumber:'只能输入数字且小数最多两位',
        minMax:'区间最小值不能大于最大值',
        notMinEmpty:'区间最小值不能为空',
        notMaxEmpty:'区间最大值不能为空',
        UOMnotEmpty:'计量单位不能为空',
        notEmpty:'区间数值不能为空',
        addInterval:'新增监测区间',
        edit:'编辑',
        monitoringInterval:'监测区间',
        maxLimit: '最大值不能超过'
    }
}